<script setup>
import DefaultModal from './DefaultModal.vue';

const emit = defineEmits(['close']);

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    maxWidth: {
        type: String,
        default: '2xl',
    },
    closeable: {
        type: Boolean,
        default: true,
    },
    overFlowVisible: {
        type: Boolean,
        default: false,
    },
});

const close = () => {
    emit('close');
};
</script>

<template>
    <DefaultModal :over-flow-visible="overFlowVisible" :show="show" :max-width="maxWidth" :closeable="closeable"
        @close="close">
        <div class="px-6 py-10">

            <div>
                <div class="text-lg">
                    <slot name="title" />
                </div>

                <div class="mt-4">
                    <slot name="content" />
                </div>
            </div>

            <div>
                <slot name="footer" />
            </div>

        </div>
    </DefaultModal>
</template>
